import { useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welkom terug!");
      // redirect is handled by the `if (user)` guard above once auth state commits
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
      <div className="hidden lg:flex flex-col justify-between p-12 text-white grain relative" style={{ background: "var(--elsa-blue)" }}>
        <div className="relative z-10">
          <img src="/elsa-logo-white.png" alt="ELSA Brussel" className="h-14 w-auto object-contain" />
        </div>
        <div className="relative z-10">
          <h1 className="font-serif text-5xl leading-tight">Beheer je organisatie.</h1>
          <p className="text-white/70 mt-4 max-w-sm">Beheer events, teamleden, partners en bekijk inzendingen — allemaal op één plek.</p>
        </div>
        <span className="text-white/40 text-sm relative z-10">Admin Dashboard</span>
      </div>

      <div className="grid place-items-center p-8 bg-[#F4F5F7]">
        <form onSubmit={submit} className="w-full max-w-sm bg-white border border-[#E2E8F0] rounded-lg p-8" data-testid="login-form">
          <h2 className="font-serif text-3xl text-[#0A3087] mb-1">Inloggen</h2>
          <p className="text-sm text-[#0B0B0C]/60 mb-6">Voer je admin-gegevens in.</p>
          <div className="space-y-4">
            <div>
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" type="email" data-testid="login-email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Wachtwoord</Label>
              <Input id="password" type="password" data-testid="login-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full py-3 rounded-md text-white font-600 text-sm transition-transform hover:-translate-y-0.5 disabled:opacity-60"
              style={{ background: "var(--elsa-blue)" }}
            >
              {loading ? "Bezig..." : "Inloggen"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
